<ngx-loading [show]="loading"></ngx-loading>
<div class="row h-100 mx-0 mt-1">
  <div class="col settings-col px-0 mx-2">
    <form class="d-flex flex-column h-100" [formGroup]="settingsFormGroup">
      <!--Amounts-->
      <div class="section-header">Preset Amounts</div>
      <div class="border d-flex flex-column">
        <div class="d-flex mx-2 mt-2">
          <div class="teal-font p-2">
            <label class="switch mb-0">
              <input type="checkbox" formControlName="enableCustomAmounts" />
              <span class="slider round"></span>
            </label>
            <span class="pl-2">Allow Custom Amount</span>
          </div>
        </div>
        <mat-form-field class="mx-2">
          <mat-label></mat-label>
          <mat-chip-list #chipList aria-label="Preset Amounts">
            <mat-chip
              *ngFor="let amount of presetAmounts; let i = index"
              [disabled]="readOnly"
              (removed)="removePresetAmount(i)"
            >
              {{ amount | currency }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
            <input
              [placeholder]="readOnly ? '' : 'New amount...'"
              [disabled]="readOnly"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addPresetAmount($event)"
            />
          </mat-chip-list>
        </mat-form-field>
      </div>

      <!--Promotions-->
      <div class="section-header mt-2">Promotion</div>
      <div class="border d-flex flex-column">
        <div class="d-flex m-2">
          <div class="teal-font p-2">
            <label class="switch mb-0">
              <input type="checkbox" formControlName="enableDiscount" />
              <span class="slider round"></span>
            </label>
            <span class="pl-2">Enable Discount</span>
          </div>
        </div>
        <mat-form-field class="w-100 px-2">
          <mat-label>Discount Type</mat-label>
          <mat-select #discountType formControlName="discountType">
            <mat-option [value]="GiftCardDiscountType.AddAmount">Add Dollar($) Amount to Gift Card</mat-option>
            <mat-option [value]="GiftCardDiscountType.AddPercent">Add Percent(%) Amount to Gift Card</mat-option>
            <mat-option [value]="GiftCardDiscountType.DiscountAmount"
              >Discount Dollar($) Amount From Purchase Price</mat-option
            >
            <mat-option [value]="GiftCardDiscountType.DiscountPercent"
              >Discount Percent(%) Amount From Purchase Price</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100 px-2">
          <mat-label
            >Value ({{
              discountType.value === GiftCardDiscountType.DiscountPercent ||
              discountType.value === GiftCardDiscountType.AddPercent
                ? '%'
                : '$'
            }})</mat-label
          >
          <input matInput type="number" formControlName="discountValue" />
        </mat-form-field>
        <mat-form-field class="w-100 px-2">
          <mat-label>Minimum Load ($)</mat-label>
          <input matInput type="number" formControlName="minLoad" />
        </mat-form-field>
        <mat-form-field *ngIf="discountType.value === GiftCardDiscountType.DiscountPercent" class="w-100 px-2">
          <mat-label>Maximum Discount ($)</mat-label>
          <input matInput type="number" formControlName="maxDiscount" />
        </mat-form-field>
        <mat-form-field *ngIf="discountType.value === GiftCardDiscountType.AddPercent" class="w-100 px-2">
          <mat-label>Maximum Add ($)</mat-label>
          <input matInput type="number" formControlName="maxDiscount" />
        </mat-form-field>
      </div>

      <!--Policy-->
      <div class="section-header mt-2">Policy</div>
      <div class="border">
        <div class="w-100 p-2">
          <textarea class="w-100 medium" formControlName="policy" rows="8"></textarea>
        </div>
      </div>

      <!-- Save or Cancel -->
      <div class="d-flex justify-content-end py-2">
        <button
          class="btn medium em-btn em-btn-green mr-2"
          type="button"
          (click)="onSave()"
          [disabled]="settingsFormGroup.pristine"
        >
          <i class="far fa-save"></i> Save
        </button>
        <button
          class="btn medium em-btn em-btn-green"
          type="button"
          (click)="onCancel()"
          [disabled]="settingsFormGroup.pristine"
        >
          <i class="far fa-minus-circle"></i> Cancel
        </button>
      </div>
    </form>
  </div>

  <div class="col d-flex flex-column px-0 mx-2">
    <!--Styles-->
    <div class="section-header">Styles</div>
    <div class="border flex-1">
      <app-gift-card-styles [parentLoading]="loading" [readOnly]="readOnly"></app-gift-card-styles>
    </div>
  </div>
</div>
